import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { HelpPageStatusEnum } from '../models/helpPageStatus.enum';

type HelpPageStatusChipProps = {
  status: HelpPageStatusEnum;
};

const chipConfig: Record<HelpPageStatusEnum, { labelKey: string; color: 'success' | 'warning' | 'grey' }> = {
  [HelpPageStatusEnum.Draft]: { labelKey: 'helpArticles:status.draft', color: 'warning' },
  [HelpPageStatusEnum.Published]: { labelKey: 'helpArticles:status.published', color: 'success' },
  [HelpPageStatusEnum.Archived]: { labelKey: 'helpArticles:status.archived', color: 'grey' },
};

export const HelpPageStatusChip = (props: HelpPageStatusChipProps) => {
  const { status } = props;
  const { t } = useTranslation('helpArticles');
  const { labelKey, color } = chipConfig[status];

  return <CustomChip label={t(labelKey)} color={color} size='small' smallRadius />;
};
